import React, {useEffect, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import RouteMap from "../../../../components/map/map.component";
import ListOfDevices from "./ListOfDevices.component";
import Notification from "../../../../layout/NotificationsDrawer/Notification.component";
import {initializeWebSocket} from "../../../../redux/user/userActions"
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useMapRef } from "../../../../context/MapRefContext.jsx";
import { store } from "../../../../redux/store";
import { cn } from "@/lib/utils";

export default function DashboardHomeView() {
  const dispatch = useDispatch();
  const devices = useSelector((state) => state.assets.devices);
  const [locations, setLocations] = useState();

  useEffect(() => {
    const validLocations = devices
      .filter(device => device.locations && device.locations[0]) 
      .map(device => [device.locations[0].lat, device.locations[0].long]);
  
    setLocations(validLocations);
  }, [devices]);

  useEffect(() => {
    if(!store.socket){
      dispatch(initializeWebSocket());
    }
  }, [dispatch]);

  return (
    <div className={cn(
      "relative flex flex-col flex-1 overflow-hidden" 
    )}>
      <div className="flex flex-col md:flex-row flex-1 overflow-hidden">
        <div className="w-full md:w-3/5 lg:w-2/3 p-1 order-1 md:order-none h-[300px] md:h-auto">
          <div className="h-full w-full rounded shadow-md bg-gray-200">
            {locations && <RouteMap route={locations} />}
          </div>
        </div>

        <div className="w-full md:w-2/5 lg:w-1/3 p-1 order-2 md:order-none flex flex-col h-[calc(100%-300px)] md:h-full">
          <div className="flex-1 overflow-y-auto bg-gray-50 rounded shadow-md">
            <ListOfDevices /> 
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-0 right-0 z-50 p-4"> 
        <Notification />
      </div>
      <ToastContainer />
    </div>
  );
} 